export var DIVIDER_APPEARANCES = Object.freeze({
  regular: 'regular',
  emphasized: 'emphasized'
});